export default __webpack_public_path__ + "static/media/Emblem of Red Ruin.099fd80c.jpg";